// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "1140px";
var _7 = "940px";
var _8 = "100%";
var _9 = "15px";
var _a = "620px";
var _b = "#f53535";
var _c = "rgba(0,0,0,.2)";
var _d = "rgba(255,255,255,.38)";
var _e = ".38";
var _f = "rgba(255,255,255,.2)";
var _10 = "#0025ff";
var _11 = "#f60";
var _12 = "#41ead4";
var _13 = "#2cdd78";
var _14 = "#66ab23";
var _15 = "#f5f5f5";
var _16 = "#c3c3c3";
var _17 = "#ececec";
var _18 = "#252525";
var _19 = "#272727";
var _1a = "#c6c6c5";
var _1b = "#333";
var _1c = "#3c3c3c";
var _1d = "#9c9b9b";
var _1e = "#8c8c8c";
var _1f = "#6f6f6e";
var _20 = "#3c3c3b";
var _21 = "#373737";
var _22 = "#6a6a69";
var _23 = "#6f6f6f";
var _24 = "#9f9e9e";
var _25 = "#282828";
var _26 = "#828181";
var _27 = "#1d1d1d";
var _28 = "#979797";
var _29 = "#9c9b9b";
var _2a = "#a7a7a6";
var _2b = "#c6c6c5";
var _2c = "#d8d8d7";
var _2d = "#dddddc";
var _2e = "72px";
var _2f = "40px";
var _30 = "36px";
var _31 = "25px";
var _32 = "18px";
var _33 = "13px";
var _34 = "#0025ff";
var _35 = "rgba(255,255,255,.12)";
var _36 = "#6535f5";
var _37 = "2px";
var _38 = "56px";
var _39 = "56px";
var _3a = "#41ead4";
var _3b = "#f60";
var _3c = "#f83600";
var _3d = "#881f00";
var _3e = "18px";
var _3f = "15px";
var _40 = "pfx-ImageUploader-module__placeholder--g1v_X";
var _41 = "pfx-ImageUploader-module__placeholder-drop-area--eExjV";
var _42 = "pfx-ImageUploader-module__placeholder-with-image--WNhXB";
var _43 = "red";
var _44 = "13px";
var _45 = "rgba(255,255,255,.07)";
var _46 = "#35465c";
var _47 = "#55acee";
var _48 = "#fff";
var _49 = "#ffce36";
var _4a = "#ffcd00";
var _4b = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "containerLarge", _7 as "containerMedium", _8 as "containerMobile", _9 as "containerPaddingMobile", _a as "containerSmall", _b as "danger", _c as "darkElement", _d as "disabled", _e as "disabledOpacity", _f as "extraLightElement", _10 as "facebook", _11 as "google", _12 as "green", _13 as "green2", _14 as "greenColor", _15 as "grey1", _16 as "grey10", _17 as "grey2", _18 as "grey25", _19 as "grey27", _1a as "grey3", _1b as "grey33", _1c as "grey3C", _1d as "grey4", _1e as "grey41", _1f as "grey5", _20 as "grey6", _21 as "grey61", _22 as "grey6A", _23 as "grey6F", _24 as "grey7", _25 as "grey8", _26 as "grey82", _27 as "grey9", _28 as "grey97", _29 as "grey9C", _2a as "greyA7", _2b as "greyC6", _2c as "greyD8", _2d as "greyDd", _2e as "header1", _2f as "header2", _30 as "header3", _31 as "header4", _32 as "header5", _33 as "header6", _34 as "klein", _35 as "lightElement", _36 as "lilac", _37 as "menuBorder", _38 as "menuHeight", _39 as "menuMobileHeight", _3a as "ocean", _3b as "orange", _3c as "orange2", _3d as "orangeDark", _3e as "paragraph", _3f as "paragraphSmall", _40 as "placeholder", _41 as "placeholderDropArea", _42 as "placeholderWithImage", _43 as "red", _44 as "subHeaderSmall", _45 as "subtleLightElement", _46 as "tumblr", _47 as "twitter", _48 as "white", _49 as "yellow", _4a as "yellowDeep", _4b as "youtube" }
